module.exports = __webpack_public_path__ + "img/register.d4f229ad.svg";